import moment from 'moment';
import {
	init,
	RematchRootState,
} from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
import createRematchPersist from '@rematch/persist';
import * as models from './rematch-models';

const currentKey = String(moment().weeks());
const keyPrefix = 'store';

// clear old store
const obsoleteKeys = Object.keys(window.localStorage).filter(x => x.startsWith(keyPrefix) && !x.endsWith(currentKey));
obsoleteKeys.forEach(x => window.localStorage.removeItem(x));

const persistPlugin = createRematchPersist({
	key: currentKey,
	whitelist: [
		'cdcCVXs',
		'compositeAllergies',
		'compositeDrugs',
		'icd10s',
		'nlmPatientEducationDefinitions',
		'phvs',
		'questOrderCodes',
		'snomeds',
		'specialties'
	],
	// throttle: 5000,
	version: 1,
	keyPrefix: keyPrefix
});

const loading = createLoadingPlugin({
	whitelist: [
		'appointments/getPastAppointmentsAsync',
		'appointments/getUpcomingAppointmentsAsync'
	]
});

export const store = init({
	models: models,
	plugins: [
		loading,
		persistPlugin
	]
});

export type Store = typeof store;
export type Dispatch = typeof store.dispatch;
export type RootState = RematchRootState<typeof models & typeof loading.config.models>;
